export default __webpack_public_path__ + "static/media/BILscreenshot.70fa726d.PNG";